module.exports = __webpack_public_path__ + "franchise-01-bg.png?38acadd5eb7f9ffc3f7c48231edcb8fc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/franchise-01-bg.png
// module id = 260
// module chunks = 0